"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Delay = void 0;
const core_1 = require("flow-connect/core");
const utils_1 = require("flow-connect/utils");
const ui_1 = require("flow-connect/ui");
class Delay extends core_1.Node {
    constructor() {
        super();
        this.eventQueue = new utils_1.List((a, b) => a.timeoutId - b.timeoutId);
    }
    setupIO() {
        this.addTerminals([
            { type: core_1.TerminalType.IN, name: "event", dataType: "event" },
            { type: core_1.TerminalType.OUT, name: "trigger", dataType: "event" },
        ]);
    }
    created(options) {
        const { width = 130, name = "Delay", style = {}, state = {} } = options;
        this.width = width;
        this.name = name;
        this.style = Object.assign({ rowHeight: 10 }, style);
        this.state = Object.assign(Object.assign({}, Delay.DefaultState), state);
        this.setupUI();
        this.setupListeners();
    }
    process() { }
    triggerEvent(eventNode) {
        if (eventNode === this.eventQueue.head) {
            let bufferedEvent = this.eventQueue.removeFirst();
            this.outputs[0].emit(bufferedEvent.data);
        }
    }
    setupUI() {
        this.ui.append(this.createUI("core/x-layout", {
            childs: [
                this.createUI("core/label", { text: "Delay", style: { grow: 0.3 } }),
                this.createUI("core/input", {
                    propName: "delay",
                    input: true,
                    output: true,
                    height: 20,
                    style: { type: ui_1.InputType.Number, grow: 0.7 },
                }),
            ],
            style: { spacing: 10 },
        }));
    }
    setupListeners() {
        this.eventQueue.on("removefirst", () => {
            while (this.eventQueue.head &&
                performance.now() - this.eventQueue.head.data.start >= this.state.delay) {
                let bufferedEvent = this.eventQueue.removeFirst(false);
                this.outputs[0].emit(bufferedEvent.data);
            }
        });
        this.inputs[0].on("event", (_, data) => {
            let eventNode = new utils_1.ListNode();
            eventNode.data = {
                data,
                timeoutId: window.setTimeout(() => this.triggerEvent(eventNode), this.state.delay),
                start: performance.now(),
            };
            this.eventQueue.append(eventNode);
        });
        this.flow.on("start", () => {
            this.eventQueue.forEach((eventNode) => {
                eventNode.data.start = performance.now() + eventNode.data.remaining - this.state.delay;
                eventNode.data.timeoutId = window.setTimeout(() => this.triggerEvent(eventNode), eventNode.data.remaining);
            });
        });
        this.flow.on("stop", () => {
            this.eventQueue.forEach((eventNode) => {
                clearTimeout(eventNode.data.timeoutId);
                eventNode.data.remaining = performance.now() - eventNode.data.start;
            });
        });
    }
}
exports.Delay = Delay;
Delay.DefaultState = { delay: 0 };
